import React, { useState, useRef } from "react";
import event1 from "../static/img/Resilience Summit Event Poster.jpg";
// import event2 from "../static/img/client feedback.png";
import event3 from "../static/img/event3.png";
import event4 from "../static/img/event4.png";
import event5 from "../static/img/event5.jpg";
import Event1 from "../pages/Event1.jsx";
import Event1dis from "../pages/Event1dis.jsx";
import Event1reg from "../pages/Event1reg.jsx";
import "../static/css/Events.css";


const Events = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const event1RegRef = useRef(null);

  const events = [
   
    {
      id: 1,
      img: event1,
      day_date: "Fri 29",
      title: "The Resilience Summit ",
      year: "2024",
      host: "by Quindl",
      date: "Fri, 29 NOV 2024, ",
      time: "7:00 PM IST",
      location: "Virtual Event - Zoom",
      ticket: 1,
    },
    {
      id: 2,
      img: event3,
      day_date: "Thurs 12",
      title: "Tech Forum Thrive",
      year: "2024",
      host: "by Quindl",
      date: "Thurs, 12 DEC 2024, ",
      time: "7:00 PM IST",
      location: "Virtual Event",
      ticket: 2,
    },
    {
      id: 3,
      img: event4,
      day_date: "Mon 20",
      title: "Innovators Hub",
      year: "2025",
      host: "by Quindl",
      date: "Mon, 20 JAN 2025, ",
      time: "7:00 PM IST",
      location: "Virtual Event",
      ticket: 2,
    },
    {
      id: 4,
      img: event5,
      day_date: "Tue 18",
      title: "LaunchPad Expo",
      year: "2025",
      host: "by Quindl",
      date: "Tue, 18 FEB 2025, ",
      time: "7:00 PM IST",
      location: "Virtual Event",
      ticket: 2,
    },
  ];

  const scrollToEventReg = () => {
    if (event1RegRef.current) {
      event1RegRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="events">
        <div className="events-text">
          <p>Events</p>
        </div>
        <div className="events-text-2">
          <p>
            Navigating Tech Opportunities to Innovate and Achieve Together.
            Explore Quindl’s Upcoming Virtual Events
          </p>
        </div>
        <div className="upcoming-events">
          <div className="upcoming-events-text">
            <p>Upcoming Events</p>
          </div>
          <div className="event-container">
            {events.map((event, index) => (
              <div
                key={index}
                className={`event ${hoveredCard === index ? "hovered" : ""}`}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="event-content">
                  <img
                    src={event.img}
                    alt={event.title}
                    className="event-image"
                  />
                  {hoveredCard === index && (
                    <div className="event-details">
                      <div className="event-detail-content">
                        <div className="event-content1">
                          <div className="event-day-date">{event.day_date}</div>
                          <div className="event-title">
                            <p>{event.title}</p>
                            <p>{event.year}</p>
                          </div>
                          <div className="event-host">{event.host}</div>
                        </div>
                        <div className="event-date-location">
                          {event.date && event.time && (
                            <div className="event-date-time">
                              <p>Date & Time</p>
                              <span>
                                {event.date} {event.time}
                              </span>
                            </div>
                          )}
                          {event.location && (
                            <div className="event-location">
                              <p>Location</p>
                              <span>{event.location}</span>
                            </div>
                          )}
                        </div>
                        {event.date && event.time && event.location ? (
                          event.ticket === 1 ? (
                            <div className="ticket-button">
                              <button onClick={scrollToEventReg}>Register Now</button>
                            </div>
                          ) : event.ticket === 0 ? (
                            <div className="ticket-button">
                              <button disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>Registration</button>
                            </div>
                          ) : (
                            <div className="ticket-button">
                              <button disabled style={{ opacity: 1, cursor: "not-allowed" }}>Upcoming Events</button>
                            </div>
                          )
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Event1 />
      <Event1dis scrollToEventReg={scrollToEventReg} />
      <Event1reg ref={event1RegRef} />
    </>
  );
};

export default Events;
